import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonOrButtonInLink } from './ButtonOrButtonInLink';
export const SimpleButton = ({ isDisplayInsideTable, item, }) => {
    if (isDisplayInsideTable) {
        return (_jsx(ButtonOrButtonInLink, { isFullWidth: isDisplayInsideTable, item: Object.assign(Object.assign({}, item), { ml: 12 }) }));
    }
    return _jsx(ButtonOrButtonInLink, { item: item });
};
//# sourceMappingURL=SimpleButton.js.map